import React, { useContext } from 'react';
import { DatetimeColumn, StringColumn, CustomColumn } from 'baseui/data-table';
import { ModalContext, EMPTY_STRING } from 'commons-ui';
import * as lodash from 'lodash';
import 'reactjs-popup/dist/index.css';
import '../../../../../modal.css';
import { Button } from 'baseui/button';
import ReactDiffViewer from 'react-diff-viewer';
import { CONFIG_DIFFERENCE, DATE_TIME_FORMAT, maxNum } from 'constant';
import { ColCellParams, ColData, COLUMN_TITILE, ValueCellParams } from '../../types';

export const COL_NAMES = {
	key: 'key',
	updatedBy: 'updatedby',
	game: 'game',
	serviceName: 'serviceName',
	newValue: 'newValue',
	oldValue: 'oldValue',
	updatedAt: 'updatedAt'
};

const renderValueCell = (params: ValueCellParams, header: string) => {
	const { value } = params;
	const { setModalConfig } = useContext(ModalContext);
	const fullView = async () => {
		setModalConfig({
			isOpen: true,
			header,
			content: (
				<div className='modal'>
					<div className='content'>
						<p>{value.fullText}</p>
					</div>
				</div>
			)
		});
	};

	return (
		<div role='button' tabIndex={0} style={{ cursor: 'pointer' }} onClick={fullView}>
			{value.previewText}
		</div>
	);
};

const processText = (data: ColData, key: 'newValue' | 'oldValue'): { fullText: string; previewText: string } => {
	let fullText: string = EMPTY_STRING;
	let previewText: string = EMPTY_STRING;

	if (!lodash.isNil(data[COL_NAMES[key]]) && (lodash.isObject(data[COL_NAMES[key]]) || lodash.isBoolean(data[COL_NAMES[key]]))) {
		fullText = JSON.stringify(data[COL_NAMES[key]]);
		previewText = fullText.length > maxNum ? `${fullText.slice(0, maxNum)}...` : fullText;
	} else {
		fullText = data[COL_NAMES[key]] || EMPTY_STRING;
		previewText = fullText.length > maxNum ? `${fullText.slice(0, maxNum)}...` : fullText;
	}
	return { fullText, previewText };
};

export const columnConfigs = [
	DatetimeColumn({
		title: COLUMN_TITILE.UPDATED_AT,
		mapDataToValue: (data: ColData) => new Date(data[COL_NAMES.updatedAt]),
		maxWidth: 200,
		formatString: DATE_TIME_FORMAT
	}),
	StringColumn({
		title: COLUMN_TITILE.KEY_NAME,
		maxWidth: 200,
		mapDataToValue: (data: ColData) => data[COL_NAMES.key] || EMPTY_STRING
	}),
	StringColumn({
		title: COLUMN_TITILE.UPDATED_BY,
		maxWidth: 200,
		mapDataToValue: (data: ColData) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	}),
	StringColumn({
		title: COLUMN_TITILE.GAME_NAME,
		maxWidth: 200,
		mapDataToValue: (data: ColData) => data[COL_NAMES.game] || EMPTY_STRING
	}),
	StringColumn({
		title: COLUMN_TITILE.SERVICE_NAME,
		maxWidth: 200,
		mapDataToValue: (data: ColData) => data[COL_NAMES.serviceName] || EMPTY_STRING
	}),
	CustomColumn({
		title: COLUMN_TITILE.NEW_VALUE,
		width: 100,
		mapDataToValue: (data: ColData) => {
			const { fullText, previewText } = processText(data, 'newValue');
			return { fullText, previewText };
		},
		renderCell: (params: any) => {
			return renderValueCell(params, COLUMN_TITILE.NEW_VALUE);
		}
	}),
	CustomColumn({
		title: COLUMN_TITILE.OLD_VALUE,
		width: 100,
		mapDataToValue: (data: ColData) => {
			const { fullText, previewText } = processText(data, 'oldValue');
			return { fullText, previewText };
		},
		renderCell: (params: any) => {
			return renderValueCell(params, COLUMN_TITILE.OLD_VALUE);
		}
	}),
	CustomColumn({
		title: COLUMN_TITILE.DIFF,
		maxWidth: 200,
		mapDataToValue: (data: ColData) => {
			return {
				newData: JSON.stringify(data[COL_NAMES.newValue]),
				oldData: JSON.stringify(data[COL_NAMES.oldValue])
			};
		},
		renderCell: (params: ColCellParams) => {
			const { value } = params;
			const { setModalConfig } = useContext(ModalContext);
			const handleConfigDiff = async () => {
				setModalConfig({
					isOpen: true,
					header: CONFIG_DIFFERENCE,
					content: (
						<div className='modal'>
							<div className='content'>
								<ReactDiffViewer oldValue={value.oldData} newValue={value.newData} splitView={false} />
							</div>
						</div>
					)
				});
			};

			return (
				<Button onClick={handleConfigDiff} size='compact'>
					Get Diff
				</Button>
			);
		}
	})
];

export const PAGE_DETAILS = {
	pageDetails: {
		pageNo: 1,
		pageSize: 2
	}
};
